import initializeReasignForm from './initializeReasignForm';
import openReasignModal from './openReasignModal';
export default (ids, callback) => (dispatch) => {
    const contacts = ids.map((id) => id);

    dispatch(initializeReasignForm({ contacts, callback }));
    dispatch(openReasignModal(true));
};
